import { render, staticRenderFns } from "./EditarServicios.vue?vue&type=template&id=4e36634c&"
import script from "./EditarServicios.vue?vue&type=script&lang=js&"
export * from "./EditarServicios.vue?vue&type=script&lang=js&"
import style0 from "./EditarServicios.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\laragon\\www\\elipse-citas\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e36634c')) {
      api.createRecord('4e36634c', component.options)
    } else {
      api.reload('4e36634c', component.options)
    }
    module.hot.accept("./EditarServicios.vue?vue&type=template&id=4e36634c&", function () {
      api.rerender('4e36634c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Subconjuntos/EditarServicios.vue"
export default component.exports